import { Map } from "immutable";

import {
  composeSelector,
  composeSelectorCreator
} from "seneca-common/utils/selectors/compose-selectors";

import SessionModule from "../../../../models/SessionModule";
import * as moduleSelectors from "./module";

export type SessionModules = Map<string, SessionModule>;

type State = SessionModules;

export function getSessionModule(
  state: State,
  sessionModuleId: string
): SessionModule {
  return state.get(sessionModuleId)!;
}

export const getContentModuleId = composeSelector(
  getSessionModule,
  moduleSelectors.getContentModuleId
);

export const getContentId = composeSelector(
  getSessionModule,
  moduleSelectors.getContentId
);

export const getWordId = composeSelector(
  getSessionModule,
  moduleSelectors.getWordId
);

export const getSkill = composeSelector(
  getSessionModule,
  moduleSelectors.getSkill
);

export const getTextToSpeechDisabled = composeSelector(
  getSessionModule,
  moduleSelectors.getTextToSpeechDisabled
);

export const getModuleType = composeSelector(
  getSessionModule,
  moduleSelectors.getModuleType
);

export const getContent = composeSelector(
  getSessionModule,
  moduleSelectors.getContent
);

export const getTestingActive = composeSelector(
  getSessionModule,
  moduleSelectors.getTestingActive
);

export const getTimeStarted = composeSelector(
  getSessionModule,
  moduleSelectors.getTimeStarted
);

export const getTimeFinished = composeSelector(
  getSessionModule,
  moduleSelectors.getTimeFinished
);

export const getModuleState = composeSelector(
  getSessionModule,
  moduleSelectors.getModuleState
);

export const getCompleted = composeSelector(
  getSessionModule,
  moduleSelectors.getCompleted
);

export const getSubmitted = composeSelector(
  getSessionModule,
  moduleSelectors.getSubmitted
);

export const getGaveUp = composeSelector(
  getSessionModule,
  moduleSelectors.getGaveUp
);

export const getUserAnswer = composeSelector(
  getSessionModule,
  moduleSelectors.getUserAnswer
);

export const getScore = composeSelector(
  getSessionModule,
  moduleSelectors.getScore
);

export const wasCorrect = composeSelector(
  getSessionModule,
  moduleSelectors.wasCorrect
);

export const wasIncorrect = composeSelector(
  getSessionModule,
  moduleSelectors.wasIncorrect
);

export const moduleStillInProgress = composeSelector(
  getSessionModule,
  moduleSelectors.moduleStillInProgress
);

export const moduleContainsGIF = composeSelector(
  getSessionModule,
  moduleSelectors.moduleContainsGIF
);

export const createScoreSelector = composeSelectorCreator(
  getSessionModule,
  moduleSelectors.createScoreSelector
);

export function isModuleInitialised(state: State, moduleId: string): boolean {
  return !!getSessionModule(state, moduleId);
}
